import { MoveHorizontalIcon, WrapTextIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Tooltip, TooltipPopup, TooltipTrigger } from "./ui/tooltip";

export function WordWrapButton({ enabled, onToggle }: { enabled: boolean; onToggle: () => void }) {
  const label = enabled ? "Disable word wrap" : "Enable word wrap";
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            size="icon-xs"
            variant="ghost"
            aria-label={label}
            aria-pressed={enabled}
            className="text-muted-foreground hover:text-foreground"
            onClick={onToggle}
          >
            {enabled ? (
              <WrapTextIcon className="size-3.5" />
            ) : (
              <MoveHorizontalIcon className="size-3.5" />
            )}
          </Button>
        }
      />
      <TooltipPopup>{label}</TooltipPopup>
    </Tooltip>
  );
}
